import { createSlice } from "@reduxjs/toolkit";
import { numericalString } from "../types";
import { DriverGPSData } from "../types/driverGPS";

const initialState: DriverGPSData = {};

export const driverGPSSlice = createSlice({
  name: "driverGPS",
  initialState,
  reducers: {
    setDriverGPSData: (state, action) => {
      for (const driverGPS of action.payload) {
        const { driver, gpsData } = driverGPS;
        state[driver as numericalString] = gpsData;
      }
    },
  },
});

export const { setDriverGPSData } = driverGPSSlice.actions;
export default driverGPSSlice.reducer;
